import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { aboutPoints } from "@/mocks/home";

export default function About() {
  return (
    <section id="about" className="scroll-mt-section bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <Reveal>
            <SectionHeading
              eyebrow="品牌介绍"
              title="先把「能做什么」讲清楚"
              subtitle="茶杯狐影视围绕内容浏览、播放与账号体系展开。这一页把常见的问题集中说明：有哪些端可以使用、会员和 VIP 有什么区别、弹幕和收藏怎么用。"
            />
            <div className="mt-6 space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                对于第一次接触的用户，最直接的路径是先从 APP 与客户端了解使用入口，再根据自己的观看习惯选择会员档位。
                如果你更关心互动与整理，可以跳到弹幕与片单收藏两个分区。
              </p>
              <p>
                页面内的模块按「了解 → 使用 → 管理」的顺序排列：开头介绍品牌与核心功能，
                中间说明各端入口与会员权益，最后是弹幕、收藏等具体体验与常见问题。
              </p>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="grid gap-4">
              {aboutPoints.map((point) => (
                <article
                  key={point.title}
                  className="flex gap-4 rounded-lg bg-background-100 border border-background-200 p-4 md:p-5"
                >
                  <span className="w-11 h-11 shrink-0 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center text-xl">
                    <i className={point.icon} />
                  </span>
                  <div>
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900">
                      {point.title}
                    </h3>
                    <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">
                      {point.desc}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}